import type {
  EpfRawData,
  EpfRawDataItem,
} from '../hooks/usePortfolioDividendEfp';

export const convertItemToTimeseries = (items: EpfRawDataItem[]) => {
  return items.map((item) => [
    new Date(item.monthYear).getTime(),
    item.valueConverted,
  ]);
};

export const getTimeseriesByType = (data: EpfRawData) => {
  if (!data) {
    return {
      declared: [],
      estimated: [],
    };
  }

  const declared = data.filter((d) => d.type === 'declared');
  const estimated = data.filter((d) => d.type === 'estimated');
  return {
    declared: convertItemToTimeseries(declared),
    estimated: convertItemToTimeseries(estimated),
  };
};
